import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import selectn from "selectn";
import { Helmet } from "react-helmet";
import qs from "qs";

import SubscriptionHeader from "../SubscriptionHeader";
import NewslettersList from "../NewslettersList";
import Newsletter from "../Newsletter";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import Spinner from "components/Library/Spinner";
import { getLocalItem } from "utils/localdb";

import {
  populateSubscription,
  getNewsletter,
  getSubscriptionNewsletters,
} from "../../actions/subscriptions";
import { setSection } from "../../../actions/navigation";

import styles from "./Subscription.css";

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.loadMoreNewsletters = this.loadMoreNewsletters.bind(this);

    this.state = {
      newsletterId: this.getNewsletterId(props),
      subscriptionId: this.getSubscriptionId(props),
    };
  }

  componentDidMount() {
    if (this.state.newsletterId) {
      const params = qs.parse(this.props.location.search.slice(1));
      const adminToken = getLocalItem("adminToken");
      if (params.preview && adminToken) {
        if (params.revision) {
          this.props.getNewsletter(this.state.newsletterId, adminToken, params.revision);
        } else {
          this.props.getNewsletter(this.state.newsletterId, adminToken);
        }
      } else {
        this.props.getNewsletter(this.state.newsletterId);
      }
    }

    this.props.populateSubscription(this.state.subscriptionId);
  }

  componentWillReceiveProps(nextProps) {
    let nextSubscriptionId = this.getSubscriptionId(nextProps);
    if (this.state.subscriptionId !== nextSubscriptionId) {
      this.setState({ subscriptionId: nextSubscriptionId });
      this.props.populateSubscription(nextSubscriptionId);
    }

    if (this.props.subscription !== nextProps.subscription) {
      this.props.setSection({ name: selectn("subscription.name", nextProps) });
    }

    let nextNewsletterId = this.getNewsletterId(nextProps);
    if ((this.state.newsletterId !== nextNewsletterId) && nextNewsletterId) {
      this.props.getNewsletter(nextNewsletterId);
      this.setState({ newsletterId: nextNewsletterId });
    }

    let nextNewsletters = selectn("subscription.subscription_newsletters", nextProps);
    //alternate loading method for first newsletter (when id isn't in url)
    //only perform this if no id in url, no newsletter already loaded, and it's not already loading

    if (!this.props.newsletter && !this.props.newsletterLoading && nextNewsletters && nextNewsletters.results.length > 0 && !nextNewsletterId) {
      this.props.getNewsletter(nextNewsletters.results[0].id);
      this.setState({ newsletterId: nextNewsletters.results[0].id });
    }
  }

  componentWillUnmount() {
    this.props.setSection(null);
  }

  getSubscriptionId(props) {
    return selectn("match.params.subscription", props);
  }

  getNewsletterId(props) {
    return selectn("match.params.newsletter", props);
  }


  loadMoreNewsletters(page) {
    this.props.getSubscriptionNewsletters(this.state.subscriptionId, page);
  }

  renderMeta() {
    let canonicalUrl = this.props.newsletter ? this.props.newsletter.permalink : this.props.subscription.permalink;
    let image = selectn("social_image.crops.16x9.url", this.props.subscription);

    if (!this.props.subscription) return null;

    if (this.props.location.search && this.props.newsletter) {
      const params = qs.parse(this.props.location.search.substring(1));
      if(params.chunk && this.props.newsletter.chunks[params.chunk]) {
        const chunk = this.props.newsletter.chunks[params.chunk];
        image = selectn("primary_image.crops.16x9.url", chunk) || image;
        return (
          <Helmet>
            <title>{this.props.newsletter.subscription.name} - Axios</title>
            <meta property="og:title" content={chunk.headline} />
            {image && <meta property="og:image" content={image} />}
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:url" content={`${canonicalUrl}?chunk=${params.chunk}#story${params.chunk}`} />
          </Helmet>
        );
      }
    }

    return (
      <Helmet>
        <title>{`${this.props.subscription.name || ""} - Axios`}</title>
        <meta property="og:title" content={this.props.subscription.name} />
        <meta property="og:url" content={canonicalUrl} />
        <link rel="canonical" href={canonicalUrl} />
        {image && <meta property="og:image" content={image} />}
        {this.props.newsletter && this.props.newsletter.preview_text && <meta property="og:description" content={this.props.newsletter.preview_text} />}
      </Helmet>
    );
  }

  render() {
    const { subscription, newsletter, newsletterLoading } = this.props;
    if (!subscription) return null;
    if (newsletterLoading || !newsletter || newsletter.id !== this.state.newsletterId) {
      return (<div>
        {this.renderMeta()}
        <Layout
          includeHeader={true}
          headerComponent={
            <SubscriptionHeader
              text={""}
              subscription={subscription}
            />
          }
        >
          <Spinner />
        </Layout>
      </div>);
    }

    return (<div>
      {this.renderMeta()}
      <Layout
        includeHeader={true}
        headerComponent={
          <SubscriptionHeader
            text={subscription.name}
            subscription={subscription}
          />
        }
      >
        <Sidebar>
          <NewslettersList
            subscriptionNewsletters={subscription.subscription_newsletters}
            newsletterId={this.state.newsletterId}
            subscriptionId={this.state.subscriptionId}
            onClickMoreIssues={this.loadMoreNewsletters}
          />
        </Sidebar>
        <Content>
          <Newsletter newsletter={newsletter} />
          <NewslettersList
            className={styles.mobileIssueList}
            subscriptionNewsletters={subscription.subscription_newsletters}
            newsletterId={this.state.newsletterId}
            subscriptionId={this.state.subscriptionId}
            onClickMoreIssues={this.loadMoreNewsletters}
          />
        </Content>
      </Layout>
    </div>);
  }
}

Subscription.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = (state) => {
  return {
    subscription: state.subscriptions.data,
    newsletter: state.newsletters.data,
    newsletterLoading: state.newsletters.isLoading,
  };
};

export default connect(mapStateToProps, {
  populateSubscription,
  getNewsletter,
  getSubscriptionNewsletters,
  setSection,
})(Subscription);



// WEBPACK FOOTER //
// ./src/subscriptions/components/Subscription/Subscription.js